// import * as types from '../mutation-types'

const state = {
    dt: null,
    prevDTState: null
}

const getters = {
    // prevDTState: state => state.prevDTState
}

const actions = {
    openProductFromNotification({commit}, id) {
        state.dt.forceID = id;
        state.dt.instance.ajax.reload(null, false)
    },
    closeProductFromNotification({commit}) {
        state.dt.forceID = null;
        state.dt.instance.ajax.reload(null, false)
    },
    setDT({commit}, dt) {
        state.dt = dt;
    }
}

const mutations = {
    // [types.OPEN_PRODUCT_FROM_NOTIFICATION] (state, {products}) {
    //     //state.all = products
    // }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/notifications.js